'use strict';
var $ = require('jquery');

function imagearrows(isReinit) {
    if (isReinit) {
        //Check if there is more than 1 item on carousel
        if ($('.product-thumbnails').find('.carousel li').length >= 2) {
            $('.main-image-arrows').show();
        } else {
            $('.main-image-arrows').hide();
        }
    } else {
        $(window).on('load', function () {
            //Check if there is more than 1 item on carousel
            if ($('.product-thumbnails').find('.carousel li').length >= 2) {
                $('.main-image-arrows').show();
            } else {
                $('.main-image-arrows').hide();
            }
        });
    }

    var $mainThumbnailContainer = $('.product-thumbnails li');
    var $bigCarouselPrev = $('.product-primary-image-container .arrows-left');
    var $bigCarouselNext = $('.product-primary-image-container .arrows-right');
    var $smallArrows = $('.product-primary-image-container .nav-arrows');
    var $smallCarouselPrev = $('.product-primary-image-container .nav-prev:not(.only-on-mobile)');
    var $smallCarouselNext = $('.product-primary-image-container .nav-next:not(.only-on-mobile)');
    var $selectedThumb = $('.product-thumbnails li.selected');
    var $productZoomLink = $('.product-image-zoom');
    var $mainPrimaryImage = $('.product-image-zoom .primary-image');
    var numMaxImages = $mainThumbnailContainer.length - 1;
    var indexImage = 0;
    var tempThumb;

    if (numMaxImages <= 4) {
        setTimeout(function () {
            $smallArrows.hide();
        }, 100);
    }

    indexImage = $selectedThumb.index();
    if (indexImage >= 0) {
        $bigCarouselPrev.addClass('disabled');
    }

    $mainThumbnailContainer.on('click', function (e) {
        var $this = $(this);
        indexImage = $this.index();
        if (indexImage != -1) {
            //console.log(indexImage +"/"+ numMaxImages);
            if (indexImage === 0) {
                $bigCarouselPrev.addClass('disabled');
                $bigCarouselNext.removeClass('disabled');
            } else {
                $bigCarouselPrev.removeClass('disabled');
            }
            if (indexImage === numMaxImages) {
                $bigCarouselNext.addClass('disabled');
                $bigCarouselPrev.removeClass('disabled');
            } else {
                $bigCarouselNext.removeClass('disabled');
            }
        }
    });

    function prevSlide() {
        var $this = $(this);
        $selectedThumb = $('.product-thumbnails li.selected');
        tempThumb = $selectedThumb.prev();
        indexImage = tempThumb.index();
        if (indexImage != -1) {
            if (indexImage >= 0) {
                //console.log(indexImage +"/"+ numMaxImages);
                tempThumb.find('img').click();
                if (!$smallCarouselPrev.hasClass('disabled')) {
                    $smallCarouselPrev.click();
                }
                if ($bigCarouselNext.hasClass('disabled')) {
                    $bigCarouselNext.removeClass('disabled');
                }
            }
            if (indexImage === 0) {
                $this.addClass('disabled');
            }
        }
    }

    function nextSlide() {
        var $this = $(this);
        $selectedThumb = $('.product-thumbnails li.selected');
        tempThumb = $selectedThumb.next();
        indexImage = tempThumb.index();
        if (indexImage != -1) {
            if (indexImage <= numMaxImages) {
                //console.log(indexImage +"/"+ numMaxImages);
                tempThumb.find('img').click();
                if (!$smallCarouselNext.hasClass('disabled')) {
                    $smallCarouselNext.click();
                }
                if ($bigCarouselPrev.hasClass('disabled')) {
                    $bigCarouselPrev.removeClass('disabled');
                }
            }
            if (indexImage === numMaxImages) {
                $this.addClass('disabled');
            }
        }
    }

    $bigCarouselPrev.on('click', function (e) {
        prevSlide();
    });
    $bigCarouselNext.on('click', function (e) {
        nextSlide();
    });

    $(document).on('keydown', function (e) {
        if (e.keyCode === 37) {
            prevSlide();
        } else if (e.keyCode === 39) {
            nextSlide();
        }
    });

    $productZoomLink.on('click', function (e) {
        e.preventDefault;
    });
    $mainPrimaryImage.on('click', function (e) {
        e.preventDefault;
    });
}

module.exports = {
    init: function () {
        imagearrows(false);
    },
    reInit: function () {
        imagearrows(true);
    }
};
